<template>
    <div class="card" style="min-height: 450px;">
        <h6 class="card-header" style="color:#348cd4;" > List of Admins</h6>

        <vue-bootstrap4-table
            :rows="rows"
            :columns="columns"
            :config="config"
            :actions="actions"
            @on-select-row="editSelected"
            @on-all-select-rows="editSelected"
            @on-unselect-row="editSelected"
            @oon-all-unselect-rows="editSelected"
            @on-delete="deleteSubAdmins">
         
            <template slot="id" slot-scope="props">
                <span>
                    {{props.row.vbt_id}}
                </span>
            </template>
            <template slot="companyRc" slot-scope="props">
                <span>
                    RC-{{props.cell_value}}
                </span>
            </template>
            <template slot="adminType" slot-scope="props">
                <span>
                    {{(props.cell_value == 1)?'Super Admin':'Admin'}}
                </span>
            </template>
            <!-- <template slot="createdat" slot-scope="props">
                <span>
                    {{props.cell_value | dateFormatter}}
                </span>
            </template> -->

            <template slot="sort-asc-icon">
                <i class="fas fa-sort-up"></i>
            </template>
            <template slot="sort-desc-icon">
                <i class="fas fa-sort-down"></i>
            </template>
            <template slot="no-sort-icon">
                <i class="fas fa-sort"></i>
            </template>
        </vue-bootstrap4-table>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import VueBootstrap4Table from 'vue-bootstrap4-table';

export default {
  name: 'ListAgents',
  components:{
    VueBootstrap4Table
  },

    data() {
        return{
            selectedDeleteRows: [],
            rows: [],
            columns: [
                {
                    label: "S/N",
                    name: "id",
                    slot_name: "id"
                },
                {
                    label: "Admin ID",
                    name: "adminId",
                    sort: true,
                },
                {
                    label: "Admin type",
                    name: "adminType",
                    slot_name: "adminType",
                    sort: true,
                },
                {
                    label: "Email",
                    name: "email",
                    sort: true,
                },
                {
                    label: "Phone",
                    name: "phone",
                    sort: true,
                },
                {
                    label: "First Name",
                    name: "firstName",
                    sort: true,
                },
                {
                    label: "Last Name",
                    name: "lastName",
                    sort: true,
                },
            ],
            actions: [
                {
                    btn_text: "Delete",
                    event_name: "on-delete",
                    class: "btn btn-danger btn-xs mx-2 disabled",
                    event_payload: this.selectedDeleteRows
                }

            ],
            config: {
                card_mode: false,
                show_refresh_button: false,
                show_reset_button: false,
                checkbox_rows: true,
                rows_selectable: true,
                selected_rows_info: true,
                global_search: {
                    placeholder: "Search Uploads",
                    visibility: false,
                    case_sensitive: false,
                },
            }
        }
    },

    computed:{
        ...mapState(['token'])
    },

    mounted(){
        this.getSubAdminList()
    },

    methods:{
        editSelected(selectedItems){
            this.selectedDeleteRows = selectedItems.selected_items
            // console.log("selectedItems-------",this.selectedDeleteRows)
        },

        getSubAdminList(){
            this.$toastr.removeByType("error"); // remove all error type message
            
            const baseU = `${this.$urlAuth}/listsubadmins`;

            this.$http.get(baseU,{
                headers:{
                    "x-access-token":this.token
                }
            })
            .then(response => {
                if(response.data.data.code =='S200'){
                    this.rows = response.data.data.subadmins

                }else{
                    this.$toastr.e(response.data.data.message);
                    this.rows = [];
                }
            })
            .catch(err => {
                console.log(err);
                this.$toastr.e("Internal server error");
            })
        },

        deleteSubAdmins({selectedItems}){
            // clean the payload 1st
            if(selectedItems.length <= 0){
                this.$toastr.e("Select data to Delete");
                return
            }

            if (!confirm(`Are you sure you want to delete the ${selectedItems.length} selected uploads? Once deleted can not be recovered!!!`)) {
                return
            }

            const deleteArr = selectedItems.map(i => i._id)
            // console.log(deleteArr)

            const baseU = `${this.$urlupload}/deleteupload`;

            this.$http.post(baseU, {deleteArr}, {
                headers:{
                    "x-access-token":this.token
                }
            })
            .then(response => {
                if(response.data.data.code =='S201'){
                    this.$toastr.s(response.data.data.message);
                    this.getAgentList()
                }else{
                    this.$toastr.e(response.data.data.message);
                }
            })
        }
    }
}
</script>